import { render, staticRenderFns } from "./PlotType.vue?vue&type=template&id=39484494&scoped=true&"
import script from "./PlotType.vue?vue&type=script&lang=js&"
export * from "./PlotType.vue?vue&type=script&lang=js&"
import style0 from "./PlotType.vue?vue&type=style&index=0&id=39484494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39484494",
  null
  
)

export default component.exports